const MESSAGE_STATUS_DOUBLE_CHECK = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision">
  <path d="M14 7L8 16L4 12"
        stroke="#79798A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"/>
  <path d="M20 7L14 16L12 14"
        stroke="#79798A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"/>
</svg>
`;

export default MESSAGE_STATUS_DOUBLE_CHECK;
